import React, { useRef } from "react";

import { cn } from "../cn";
import { Search, X } from "../icons";
import { Input, type InputProps } from "./input";

export type SearchInputProps = Omit<InputProps, "type"> & {
  onClear?: () => void;
  clearAriaLabel?: string;
  wrapperClassName?: string;
  compact?: boolean;
};
export function SearchInput({ className, wrapperClassName, value, onClear, clearAriaLabel, compact = false, ...props }: SearchInputProps) {
  const wrapRef = useRef<HTMLDivElement>(null);
  const hasValue = value != null && String(value).length > 0;

  return (
    <div ref={wrapRef} className={cn("tw-group tw-relative tw-w-full", wrapperClassName)}>
      <Search className={cn("tw-pointer-events-none tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-text-muted-foreground", compact ? "tw-left-2.5 tw-size-3.5" : "tw-left-3 tw-size-4")} aria-hidden />
      <Input
        type="search"
        value={value}
        className={cn("tw-rounded-rd [&::-webkit-search-cancel-button]:tw-appearance-none", compact ? "tw-h-8 tw-px-8 tw-text-xs" : "tw-h-10 tw-px-9", className)}
        {...props}
      />
      {hasValue && onClear ? (
        <button
          type="button"
          aria-label={clearAriaLabel}
          onClick={() => {
            onClear();
            wrapRef.current?.querySelector("input")?.focus();
          }}
          className={cn(
            "tw-absolute tw-top-1/2 tw-flex -tw-translate-y-1/2 tw-cursor-pointer tw-items-center tw-justify-center",
            "tw-rounded-md tw-border-0 tw-bg-transparent tw-p-0 tw-text-muted-foreground tw-transition-colors hover:tw-text-foreground",
            compact ? "tw-right-1.5 tw-size-5" : "tw-right-2 tw-size-6",
          )}
        >
          <X className={compact ? "tw-size-3.5" : "tw-size-4"} aria-hidden />
        </button>
      ) : null}
    </div>
  );
}
